import { TIMEZONE } from "@/constants/time"
import dayjs from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)
dayjs.extend(timezone)

export const formatSessionTime = ({
  date,
  startTime,
  endTime
}: {
  date?: number
  startTime: string
  endTime: string
}) => {
  const startTimeObj = dayjs(startTime).tz(TIMEZONE.KST)
  const endTimeObj = dayjs(endTime).tz(TIMEZONE.KST)

  const dateStr = startTimeObj.format("MM.DD ddd").toUpperCase()

  const startTimeStr = startTimeObj.format("HH:mm")
  const endTimeStr = endTimeObj.format("HH:mm")

  return `DAY ${date} | ${dateStr} / ${startTimeStr} ~ ${endTimeStr}`
}
